import axios, { API_URL } from './BaseService';

const SETTINGS_URL = `${API_URL}/settings`;

export async function getSettings() {
    const response = await axios.get(SETTINGS_URL);
    return response.data;
}

export async function updateSettings(settings) {
    
    const response = await axios.patch(SETTINGS_URL, settings);
    return response.data;
}